import { useState, useCallback, useEffect, useRef } from 'react';
import auth from 'utils/auth';

export function useGoogleSignIn({ onSuccess, onError }) {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleGoogleSignIn = useCallback(
    async (idToken: string) => {
      if (!isMounted.current) return;

      setIsGoogleLoading(true);
      try {
        const user = await auth.logInWithGoogle(idToken);

        if (!auth.loggedIn()) {
          throw new Error('Google authentication failed');
        }

        auth.setUser?.(user);
        onSuccess?.(user);
      } catch (error) {
        onError?.(error);
      } finally {
        if (isMounted.current) {
          setIsGoogleLoading(false);
        }
      }
    },
    [onSuccess, onError]
  );

  return { handleGoogleSignIn, isGoogleLoading };
}
